import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE, abs } from "../../config/site";

/**
 * Per-page document head: title, description, canonical, Open Graph / Twitter,
 * and optional JSON-LD structured data.
 *
 *  <Seo title="Shop" description="…" path="/shop" jsonLd={productLd} />
 *
 * Note: this is a client-side SPA, so JS-rendering crawlers (Google) see these
 * tags. Non-JS social scrapers fall back to the static defaults in index.html.
 */
export default function Seo({
  title,
  description,
  path = "",
  image,
  type = "website",
  noindex = false,
  jsonLd,
}) {
  const fullTitle = title ? `${title} · ${SITE.name}` : `${SITE.name} — ${SITE.tagline}`;
  const desc = description || SITE.description;
  const url = abs(path);
  const img = abs(image || SITE.ogImage);
  const blocks = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {blocks.map((block, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(block)}
        </script>
      ))}
    </Helmet>
  );
}
